import React from "react";
import {OrbitComponent} from "../../components/base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {LoadingDotBox} from "./boxes/loading-dot.box";
import {LoadingDotsBox} from "./boxes/loading-dots.box";

export const LoadingDotsComponent = observer(class LoadingDotsComponent extends OrbitComponent {
    render() {
        return (<LoadingDotsBox>
            <LoadingDotBox animationDelay={"0s"}/>
            <LoadingDotBox animationDelay={"0.32s"}/>
            <LoadingDotBox animationDelay={"0.64s"}/>
        </LoadingDotsBox>);
    }

});